import React from 'react';
import PropTypes from 'prop-types';
import {getStatusNameByAccuracy, getStatusNameByAccuracyForStudent} from 'lib/StatsUtil';
import sessionStore from 'client/Session/SessionStore';

/*
  `flag--x` classes are in _flags.scss
*/
export default class MasteryFlag extends React.Component {
  static propTypes = {
    accuracy: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    hasStarted: PropTypes.bool,
    showPercentage: PropTypes.bool
  };

  getStatusClassForStatus(status) {
    return 'mastery-status flag--' + status.toLowerCase();
  }

  render() {
    const status = sessionStore.isTeacher()
      ? getStatusNameByAccuracy(this.props.accuracy, this.props.hasStarted)
      : getStatusNameByAccuracyForStudent(this.props.accuracy);
    const statusClass = this.props.hasStarted ? this.getStatusClassForStatus(status) : '';

    if (this.props.showPercentage) {
      // If this value is not displayable, don't display it.
      if (this.props.accuracy) {
        // Taking toFixed(0) here as a safety precaution, for display purposes only
        return <span className={statusClass}>{`${this.props.accuracy}%`}</span>;
      }
      // TODO: should this be 'n/a'?
      return <span className={statusClass}>{`0%`}</span>;
    }
    return <span className={statusClass}>{status}</span>;
  }
}
